<template>
  <span class="dashboard-menu-branch-root">
    <!-- nav:dashboard -->
    <sidebar-item
      v-if="isNav('dashboard')"
      class="text-white"
      :key="'nav-dashboard'"
      :link="{
        name: d.$t('Dashboard'),
        icon: 'home',
        path: '/dashboard',
      }"
    />

    <sidebar-item
      v-else-if="branch.kind === 'customLink'"
      class="text-white"
      :key="'cu-' + (branch.cid || branch.href)"
      :link="{
        name: branch.label,
        icon: branch.icon || 'link',
        path: branch.href,
      }"
    />

    <dashboard-sidebar-settings-block
      v-else-if="isNav('settings') && branch.legacyBlock"
    />

    <sidebar-item
      v-else-if="isNav('settings')"
      class="text-white"
      :key="'nav-settings'"
      :menu="true"
      :link="{
        name: d.$t('Settings'),
        icon: 'circle',
      }"
    >
      <dashboard-menu-branch
        v-for="(ch, idx) in branch.children || []"
        :key="'set-' + idx + '-' + childKey(ch)"
        :branch="ch"
      />
    </sidebar-item>

    <sidebar-item
      v-else-if="isNav('stock') && d.canAccessStockModule"
      class="text-white"
      :key="'nav-stock'"
      :link="{
        name: menuTitle(d.$t('Stock')),
        icon: 'boxes',
        path: `/stock`,
      }"
    />

    <sidebar-item
      v-else-if="isNav('containers') && d.canAccessStockModule"
      class="text-white"
      :key="'nav-containers'"
      :link="{
        name: menuTitle(d.$t('Containers')),
        icon: 'shipping-fast',
        path: `/containers`,
      }"
    />

    <sidebar-item
      v-else-if="reportMenuItem"
      class="text-white"
      :key="'report-' + reportMenuItem._id"
      :link="{
        name: reportMenuItem.name,
        icon: reportMenuItem.icon || 'file-alt',
        path: `/dynamic-model/${reportMenuItem.modelName}?reportId=${reportMenuItem._id}`,
      }"
    />

    <!-- model:* (reportes como ítems sueltos report:id, no dentro del submenú) -->
    <sidebar-item
      v-else-if="modelWithReports"
      class="text-white"
      :class="modelEntity.modelName.toLowerCase()"
      :key="modelEntity.modelName + '-with-reports'"
      :link="{
        name: menuTitle(
          modelEntity.label
            ? d.$t(modelEntity.label)
            : d.$t(modelEntity.modelName)
        ),
        icon: modelEntity.icon || 'circle',
      }"
    >
      <sidebar-item
        class="text-white"
        :link="{
          name: d.$t('All'),
          icon: 'list',
          path: `/dynamic-model/${modelEntity.modelName}`,
        }"
      />
      <sidebar-item
        v-if="d.canAddDynamicModel(modelEntity.modelName) && !branch.hideAddNew"
        class="text-white"
        :link="{
          name: d.$t('Add new'),
          icon: 'plus',
          path: `/dynamic-model/${modelEntity.modelName}/add`,
        }"
      />
      <sidebar-item
        v-for="group in d.getGroupFieldsInMenu(modelEntity)"
        :key="group.modelName"
        class="text-white"
        :link="{
          name: group.label ? d.$t(group.label) : d.$t(group.key),
          icon: 'layer-group',
          path: `/dynamic-model/${group.modelName}`,
        }"
      />
      <dashboard-menu-branch
        v-for="(ch, idx) in branch.children || []"
        :key="'ml-' + modelEntity.modelName + '-' + idx + '-' + childKey(ch)"
        :branch="ch"
      />
    </sidebar-item>

    <sidebar-item
      v-else-if="modelWithGroupMenu"
      class="text-white"
      :class="modelEntity.modelName.toLowerCase()"
      :key="modelEntity.modelName + '-with-group-menu'"
      :link="{
        name: menuTitle(
          modelEntity.label
            ? d.$t(modelEntity.label)
            : d.$t(modelEntity.modelName)
        ),
        icon: modelEntity.icon || 'circle',
      }"
    >
      <sidebar-item
        class="text-white"
        :link="{
          name: d.$t('All'),
          icon: 'list',
          path: `/dynamic-model/${modelEntity.modelName}`,
        }"
      />
      <sidebar-item
        v-if="d.canAddDynamicModel(modelEntity.modelName) && !branch.hideAddNew"
        class="text-white"
        :link="{
          name: d.$t('Add new'),
          icon: 'plus',
          path: `/dynamic-model/${modelEntity.modelName}/add`,
        }"
      />
      <sidebar-item
        v-for="group in d.getGroupFieldsInMenu(modelEntity)"
        :key="group.modelName"
        class="text-white"
        :link="{
          name: group.label ? d.$t(group.label) : d.$t(group.key),
          icon: 'layer-group',
          path: `/dynamic-model/${group.modelName}`,
        }"
      />
      <dashboard-menu-branch
        v-for="(ch, idx) in branch.children || []"
        :key="'mlg-' + modelEntity.modelName + '-' + idx + '-' + childKey(ch)"
        :branch="ch"
      />
    </sidebar-item>

    <sidebar-item
      v-else-if="modelDirect"
      class="text-white"
      :class="modelEntity.modelName.toLowerCase()"
      :key="modelEntity.modelName"
      :link="{
        name: menuTitle(
          modelEntity.label
            ? d.$t(modelEntity.label)
            : d.$t(modelEntity.modelName)
        ),
        icon: modelEntity.icon || 'circle',
      }"
    >
      <sidebar-item
        class="text-white"
        :link="{
          name: d.$t('All'),
          icon: 'list',
          path: `/dynamic-model/${modelEntity.modelName}`,
        }"
      />
      <sidebar-item
        v-if="d.canAddDynamicModel(modelEntity.modelName) && !branch.hideAddNew"
        class="text-white"
        :link="{
          name: d.$t('Add new'),
          icon: 'plus',
          path: `/dynamic-model/${modelEntity.modelName}/add`,
        }"
      />
      <dashboard-menu-branch
        v-for="(ch, idx) in branch.children || []"
        :key="'mld-' + modelEntity.modelName + '-' + idx + '-' + childKey(ch)"
        :branch="ch"
      />
    </sidebar-item>

    <sidebar-item
      v-else-if="
        isNav('financial') && d.canAccessFinancialModuleWithPermissions
      "
      class="text-white"
      :key="'nav-fin'"
      :link="{
        name: menuTitle('Finance'),
        icon: 'chart-line',
        path: `/financial`,
      }"
    >
      <sidebar-item
        v-if="d.canAccessFinancialDashboard"
        class="text-white"
        :key="'fin-1'"
        :link="{
          name: d.$t('Dashboard'),
          icon: 'tachometer-alt',
          path: `/financial`,
        }"
      />
      <sidebar-item
        v-if="d.canAccessFinancialPayments"
        class="text-white"
        :key="'fin-2'"
        :link="{
          name: d.$t('Payments'),
          icon: 'credit-card',
          path: `/financial/payments`,
        }"
      />
      <sidebar-item
        v-if="d.canAccessFinancialExpenses"
        class="text-white"
        :key="'fin-3'"
        :link="{
          name: d.$t('Expenses'),
          icon: 'receipt',
          path: `/financial/expenses`,
        }"
      />
      <sidebar-item
        v-if="d.canAccessFinancialCollections"
        class="text-white"
        :key="'fin-4'"
        :link="{
          name: d.$t('Collections'),
          icon: 'money-bill-wave',
          path: `/financial/collects`,
        }"
      />
      <sidebar-item
        v-if="d.canAccessFinancialAccountStatement"
        class="text-white"
        :key="'fin-5'"
        :link="{
          name: d.$t('Account Statement'),
          icon: 'file-invoice',
          path: `/financial/account-statement`,
        }"
      />
    </sidebar-item>

    <sidebar-item
      v-else-if="isNav('accounting') && d.canAccessAccountingModule"
      class="text-white"
      :key="'nav-acc'"
      :link="{
        name: menuTitle('Accounting'),
        icon: 'book',
        path: `/accounting`,
      }"
    />

    <sidebar-item
      v-else-if="isNav('dhl') && d.canAccessDHLModule"
      class="text-white"
      :key="'nav-dhl'"
      :link="{
        name: menuTitle('DHL Tracking'),
        icon: 'truck',
        path: `/dhl/tracking`,
      }"
    />

    <sidebar-item
      v-else-if="isNav('ft_container') && d.canAccessFindTeuModule"
      class="text-white"
      :key="'nav-ft'"
      :link="{
        name: menuTitle('Container tracking'),
        icon: 'boxes',
        path: `/ft/container-tracking`,
      }"
    />

    <sidebar-item
      v-else-if="isNav('comexstats') && d.canAccessComexstatsModule"
      class="text-white"
      :key="'nav-comex'"
      :link="{
        name: menuTitle(d.$t('comexstats.menuItem')),
        icon: d.comexstatsModuleMenuItem.icon,
        path: d.comexstatsModuleMenuItem.path,
      }"
    />

    <sidebar-item
      v-else-if="isNav('history') && d.canAccessHistoryModule"
      class="text-white"
      :key="'nav-history'"
      :link="{
        name: menuTitle(d.$t('history.menuItem')),
        icon: d.historyModuleMenuItem.icon,
        path: d.historyModuleMenuItem.path,
      }"
    />

    <sidebar-item
      v-else-if="isNav('mev') && d.canAccessMevModule"
      class="text-white"
      :key="'nav-mev'"
      :link="{
        name: menuTitle('MEV — Causas'),
        icon: d.mevModuleMenuItem.icon,
        path: d.mevModuleMenuItem.path,
      }"
    />

    <sidebar-item
      v-else-if="isNav('outlook') && d.canAccessOutlookModule"
      class="text-white"
      :key="'nav-outlook'"
      :link="{
        name: menuTitle(d.$t('outlook.mailTitle')),
        icon: d.outlookModuleMenuItem.icon,
        path: d.outlookModuleMenuItem.path,
      }"
    />

    <sidebar-item
      v-else-if="isNav('nota_comercial') && d.canAccessNotaComercialModule"
      class="text-white"
      :key="'nav-nota-comercial'"
      :link="{
        name: menuTitle('Notas comerciales'),
        icon: d.notaComercialModuleMenuItem.icon,
        path: d.notaComercialModuleMenuItem.path,
      }"
    />

    <sidebar-item
      v-else-if="isNav('alisof') && d.canAccessAlisofModule"
      class="text-white"
      :key="'nav-alisof'"
      :link="{
        name: menuTitle('Traducciones Alisof'),
        icon: d.alisofModuleMenuItem.icon,
        path: d.alisofModuleMenuItem.path,
      }"
    />

    <sidebar-item
      v-else-if="isNav('alisof_posiciones') && d.canAccessAlisofModule"
      class="text-white"
      :key="'nav-alisof-posiciones'"
      :link="{
        name: menuTitle('Posiciones'),
        icon: d.alisofPosicionesMenuItem.icon,
        path: d.alisofPosicionesMenuItem.path,
      }"
    />

    <sidebar-item
      v-else-if="isNav('bolsa_comerciales') && d.canAccessBolsaComercialesModule"
      class="text-white"
      :key="'nav-bolsa-comerciales'"
      :link="{
        name: menuTitle(d.$t('bolsaComerciales.menuItem')),
        icon: d.bolsaComercialesModuleMenuItem.icon,
        path: d.bolsaComercialesModuleMenuItem.path,
      }"
    >
      <sidebar-item
        v-if="d.canAccessBolsaComercialesDashboard"
        class="text-white"
        :key="'bolsa-dashboard'"
        :link="{
          name: d.$t('bolsaComerciales.dashboardMenu'),
          icon: 'tachometer-alt',
          path: d.bolsaComercialesModuleMenuItem.path,
        }"
      />
      <sidebar-item
        v-if="d.canAccessBolsaComercialesSettings"
        class="text-white"
        :key="'bolsa-settings'"
        :link="{
          name: d.$t('bolsaComerciales.settingsMenu'),
          icon: 'cog',
          path: '/bolsa-comerciales/settings',
        }"
      />
    </sidebar-item>

    <sidebar-item
      v-else-if="isNav('facturacion_abogados') && d.canAccessFacturacionAbogadosModule"
      class="text-white"
      :key="'nav-fact-abog'"
      :link="{
        name: menuTitle('Facturacion abogados'),
        icon: d.facturacionAbogadosModuleMenuItem.icon,
        path: d.facturacionAbogadosModuleMenuItem.path,
      }"
    />

    <sidebar-item
      v-else-if="isNav('jurisprudencia') && d.canAccessJurisprudenciaModule"
      class="text-white"
      :key="'nav-juris'"
      :link="{
        name: menuTitle(d.$t('jurisprudencia.menuItem')),
        icon: d.jurisprudenciaModuleMenuItem.icon,
        path: d.jurisprudenciaModuleMenuItem.path,
      }"
    />

    <sidebar-item
      v-else-if="isNav('agent_chat') && d.canAccessAgentChat"
      class="text-white"
      :key="'nav-agent-chat'"
      :link="{
        name: menuTitle(d.$t('ai.agentChatTitle')),
        icon: d.agentChatMenuItem.icon,
        path: d.agentChatMenuItem.path,
      }"
    />

    <sidebar-item
      v-else-if="isNav('inmobiliaria') && d.canAccessInmobiliariaModule"
      class="text-white"
      :key="'nav-inmobiliaria'"
      :link="{
        name: menuTitle(d.$t('inmobiliaria.menuItem')),
        icon: d.inmobiliariaModuleMenuItem.icon,
        path: d.inmobiliariaModuleMenuItem.path,
      }"
    />

    <sidebar-item
      v-else-if="isNav('excel_mapping') && d.canAccessExcelMappingModule"
      class="text-white"
      :key="'nav-excel'"
      :link="{
        name: menuTitle(d.$t('excelMapping.menuItem') || 'Excel Mapping'),
        icon: 'file-excel',
        path: `/excel-mapping`,
      }"
    />

    <sidebar-item
      v-else-if="isNav('websites') && d.canAccessWebsiteModule"
      class="text-white"
      :key="'nav-web'"
      :link="{
        name: menuTitle(d.$t('websites.menuItem')),
        icon: 'language',
        path: `/websites`,
      }"
    />

    <sidebar-item
      v-else-if="isNav('emails') && d.canAccessEmailModule"
      class="text-white"
      :key="'nav-email'"
      :link="{
        name: menuTitle(d.$t('emails.title')),
        icon: 'envelope',
        path: `/emails`,
      }"
    />

    <sidebar-item
      v-else-if="isNav('translations') && d.canAccessTranslationsModule"
      class="text-white"
      :key="'nav-tr'"
      :link="{
        name: menuTitle(d.$t('translations.title')),
        icon: 'language',
        path: `/translations`,
      }"
    />

    <sidebar-item
      v-else-if="isNav('support') && d.canAccessSupportModule"
      class="text-white"
      :key="'nav-sup'"
      :link="{
        name: d.$t('Technical support'),
        icon: 'headset',
        path: d.supportUnreadMentionTicketId
          ? `/support/tickets/${d.supportUnreadMentionTicketId}`
          : `/support/tickets`,
        mentionBadge: d.supportUnreadMentions,
      }"
    />

    <sidebar-item
      v-else-if="isNav('instance_builder') && d.canAccessInstanceBuilderModule"
      class="text-white"
      :key="'nav-ib'"
      :link="{
        name: menuTitle('Instance Builder'),
        icon: 'magic',
        path: `/instance-builder`,
      }"
    />

    <sidebar-item
      v-else-if="isNav('chat') && d.isChatModuleActive"
      class="text-white"
      :key="'nav-chat'"
      :link="{
        name: menuTitle(d.$t('Chat') || 'Chat'),
        icon: 'comment',
        path: `/chat`,
      }"
    />

    <sidebar-item
      v-else-if="isNav('cronjobs') && d.isCronjobsModuleActive && d.isAdminRole"
      class="text-white"
      :key="'nav-cron'"
      :link="{
        name: menuTitle(d.cronjobsModuleMenuItem.name),
        icon: d.cronjobsModuleMenuItem.icon,
        path: d.cronjobsModuleMenuItem.path,
      }"
    />

    <sidebar-item
      v-else-if="
        isSettings('system_config') && d.hasPermission('settings_manage')
      "
      class="text-white"
      :key="'settings-system-config'"
      :link="{
        name: menuTitle(d.$t('System Configuration') || 'System Configuration'),
        icon: 'cog',
        path: `/settings`,
      }"
    />

    <sidebar-item
      v-else-if="
        isSettings('model_reference_mapping') &&
        d.hasPermission('model-definitions.view')
      "
      class="text-white"
      :key="'settings-model-reference-mapping'"
      :link="{
        name: menuTitle('Model Mapping'),
        icon: 'retweet',
        path: `/gotrading/model-reference-mapping`,
      }"
    />

    <sidebar-item
      v-else-if="
        isSettings('model_definitions') &&
        d.hasPermission('model-definitions.view')
      "
      class="text-white"
      :key="'settings-model-definitions'"
      :link="{
        name: menuTitle('Model Definitions'),
        icon: 'sitemap',
        path: `/model-definitions`,
      }"
    />

    <sidebar-item
      v-else-if="isSettings('hook_automations') && d.isAdminRole"
      class="text-white"
      :key="'settings-hook-automations'"
      :link="{
        name: menuTitle('Hook automations'),
        icon: 'bolt',
        path: `/hook-automations`,
      }"
    />

    <sidebar-item
      v-else-if="isSettings('views') && d.hasPermission('views.view')"
      class="text-white"
      :key="'settings-views'"
      :link="{
        name: menuTitle('Views'),
        icon: 'eye',
        path: `/views`,
      }"
    />

    <sidebar-item
      v-else-if="isSettings('roles') && d.hasPermission('roles.view')"
      class="text-white"
      :key="'settings-roles'"
      :link="{
        name: menuTitle('Roles'),
        icon: 'user',
        path: `/roles`,
      }"
    />

    <sidebar-item
      v-else-if="isSettings('users') && d.canAccessUsersSettings()"
      class="text-white"
      :key="'settings-users'"
      :link="{
        name: menuTitle(d.$t('Users')),
        icon: 'users',
        path: `/users`,
      }"
    />

    <sidebar-item
      v-else-if="isSettings('lists') && d.hasPermission('lists.view')"
      class="text-white"
      :key="'settings-lists'"
      :link="{
        name: menuTitle(d.$t('Lists')),
        icon: 'list',
        path: `/lists`,
      }"
    />

    <sidebar-item
      v-else-if="isSettings('admin_links') && d.hasPermission('views.view')"
      class="text-white"
      :key="'settings-admin-links'"
      :link="{
        name: menuTitle('Links'),
        icon: 'link',
        path: `/gotrading/admin-links`,
      }"
    />

    <sidebar-item
      v-else-if="isSettings('modules') && d.hasPermission('settings_manage') && d.isAdminRole"
      class="text-white"
      :key="'settings-modules'"
      :link="{
        name: menuTitle('Módulos del Sistema'),
        icon: 'box',
        path: `/modules`,
      }"
    />

    <sidebar-item
      v-else-if="
        isSettings('relationships') && d.hasPermission('settings_manage')
      "
      class="text-white"
      :key="'settings-relationships'"
      :link="{
        name: menuTitle('Relaciones'),
        icon: 'link',
        path: `/relationships`,
      }"
    />

    <sidebar-item
      v-else-if="
        isSettings('prompt_settings') && d.hasPermission('settings_manage')
      "
      class="text-white"
      :key="'settings-prompt-settings'"
      :link="{
        name: menuTitle('Prompts IA'),
        icon: 'robot',
        path: `/gotrading/prompt-settings`,
      }"
    />

    <sidebar-item
      v-else-if="isSettings('orphans') && d.isAdminRole"
      class="text-white"
      :key="'settings-orphans'"
      :link="{
        name: menuTitle(d.$t('Orphans') || 'Orphans'),
        icon: 'unlink',
        path: `/settings/orphans`,
      }"
    />

    <sidebar-item
      v-else-if="branch.kind === 'folder'"
      class="text-white menu-user-folder"
      :key="'folder-' + branch.id"
      :menu="true"
      :link="{
        name: folderTitle,
        icon: branch.icon || 'folder',
      }"
    >
      <dashboard-menu-branch
        v-for="(ch, idx) in branch.children"
        :key="'fc-' + branch.id + '-' + idx + '-' + childKey(ch)"
        :branch="ch"
      />
    </sidebar-item>
  </span>
</template>

<script>
import DashboardSidebarSettingsBlock from "./DashboardSidebarSettingsBlock.vue";

export default {
  name: "DashboardMenuBranch",
  components: {
    DashboardSidebarSettingsBlock,
    DashboardMenuBranch: () => import("./DashboardMenuBranch.vue"),
  },
  inject: ["dashboardLayout"],
  props: {
    branch: {
      type: Object,
      required: true,
    },
  },
  computed: {
    d() {
      return this.dashboardLayout;
    },
    builtinRef() {
      return this.branch.kind === "builtin" ? this.branch.ref : "";
    },
    reportMenuItem() {
      if (this.branch.kind !== "builtin") return null;
      if (!this.builtinRef.startsWith("report:")) return null;
      const id = this.builtinRef.slice(7);
      const rep = (this.d.reports || []).find((r) => String(r._id) === id);
      if (!rep || !rep.modelName) return null;
      const allowed = this.d.filteredModels.some(
        (m) => m.modelName === rep.modelName
      );
      return allowed ? rep : null;
    },
    modelEntity() {
      if (!this.builtinRef.startsWith("model:")) return null;
      const name = this.builtinRef.slice(6);
      const m = this.d.models.find(
        (x) => x.modelName && x.modelName.toLowerCase() === name.toLowerCase()
      );
      return m || null;
    },
    modelAllowed() {
      if (!this.modelEntity) return false;
      return this.d.filteredModels.some(
        (m) => m.modelName === this.modelEntity.modelName
      );
    },
    modelWithReports() {
      if (!this.modelAllowed || !this.modelEntity) return false;
      return this.d.getModelReports(this.modelEntity.modelName).length > 0;
    },
    modelWithGroupMenu() {
      if (!this.modelAllowed || !this.modelEntity) return false;
      if (this.modelWithReports) return false;
      return this.d.getGroupFieldsInMenu(this.modelEntity).length > 0;
    },
    modelDirect() {
      if (!this.modelAllowed || !this.modelEntity) return false;
      if (this.modelWithReports) return false;
      if (this.modelWithGroupMenu) return false;
      return true;
    },
    folderTitle() {
      if (this.branch.kind !== "folder") return "";
      return this.branch.label || "";
    },
  },
  methods: {
    menuTitle(defaultName) {
      const ml = this.branch && this.branch.menuLabel;
      if (ml != null && String(ml).trim() !== "") {
        return String(ml).trim();
      }
      return defaultName;
    },
    isNav(key) {
      if (this.branch.kind !== "builtin") return false;
      return this.builtinRef === `nav:${key}`;
    },
    isSettings(key) {
      if (this.branch.kind !== "builtin") return false;
      return this.builtinRef === `settings:${key}`;
    },
    childKey(ch) {
      if (ch.kind === "builtin") return ch.ref || "x";
      if (ch.kind === "folder") return ch.id || "f";
      if (ch.kind === "customLink") return ch.cid || ch.href || "cu";
      return "u";
    },
  },
};
</script>

<style scoped>
.dashboard-menu-branch-root {
  display: contents;
}
</style>
